module.exports = __webpack_public_path__ + "img/fragile-active.51fdb615.svg";